import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import Description from "../../Components/Description?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";

import ActionRequiredImage from "../../Images/ActionRequiredImage.svg";

function AccountActivateNotification(props) {
  document.title = "myBooks | Account Activate Notification";
  const history = useHistory();

  useEffect(() => {
    if (props.requiredEmail === "") {
      //history.push("/myBooks/login");
    }
  }, [props, history]);

  return (
    <div className="App col-12 d-flex align-items-center myBooks">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column margin-interaction-card">
              <div className="font-20-600 text-align-left">
                Account Activation Notification
              </div>
              <Description
                className="description"
                text="Activate your account to keep it safe"
              ></Description>
              <img
                src={ActionRequiredImage}
                alt=""
                className="forget-password-image mt-3"
              />
              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 d-lg-flex d-block align-items-center">
            <div className="mx-auto margin-interaction-card interaction-card">
              <div className="d-flex flex-wrap justify-content-center pb-lg-3">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myBooks_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <h2 className="heading black bold mt-5 mt-lg-0">
                Account Activation Required
              </h2>
              <p className="poppins-14 Color-9C9C9C pt-lg-4 pb-lg-3 text-left font-18">
                An E-mail with verification link has been sent to{" "}
                {props.requiredEmail} .
              </p>
              <p className="poppins-14 Color-9C9C9C pt-lg-2 pb-lg-3 text-left font-18">
                Can’t find an Email ? Please check your spam folder too..
              </p>
              <button
                className={`button`}
                onClick={() => {
                  props.clearEmail();
                }}
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountActivateNotification;
